/*!
 * AMOUR amour.si / amourparfums.* — Qikify Smart Cart i18n shim.
 *
 * The Qikify Smart Cart v2 app ships with a number of strings that the
 * merchant cannot translate from the Shopify Theme Editor or the app's
 * own admin (e.g. the discount-code "Apply" button — selector
 * `.qsc2-sf-content__action-btn`, the recommendation tile aria-labels
 * "Add to cart button" / "Checkout button" / "Decrease quantity button"
 * / "Remove item button", and the "Clear all items in your cart?"
 * confirm dialog). They render verbatim in English regardless of the
 * Shopify storefront locale, which looks broken on a Slovenian / German
 * / Croatian / Hungarian / Italian storefront.
 *
 * This shim runs on the front-end and rewrites those strings to match
 * the current locale. Strategy:
 *
 *   1. Pick the locale from `Shopify.locale` (set by Shopify on every
 *      page render and reflects the current path-prefix or domain
 *      mapping on multi-locale stores). Fall back to <html lang>.
 *   2. Maintain a per-locale dictionary keyed by the verbatim English
 *      default. Match the textContent of relevant elements (and a few
 *      well-known aria-labels), case-insensitively, and rewrite when a
 *      hit is found.
 *   3. Rescan on a debounced MutationObserver because the cart drawer
 *      and its inner sub-panels (Apply discount, Recommendations
 *      slider, Subscribe-and-save, etc.) mount lazily after first
 *      interaction and re-render on quantity changes.
 *
 * Defensive guarantees:
 *   - Host-guarded (only AMOUR-owned storefronts).
 *   - Idempotent: each translated node gets `data-amour-i18n="1"` so we
 *     don't repeatedly clobber Qikify if it later replaces the text in
 *     the localized form (defensive against future app updates).
 *   - All DOM work wrapped in try/catch — never throws into the page.
 */
(function () {
  'use strict';
/* AMOUR_QIKIFY_MALWARE_GUARD_START */
(function amourQikifyMalwareGuard() {
  'use strict';

  var SAFE_MSG = {
    pl: '<i>Koszty wysyłki i podatki są obliczane przy kasie</i>',
    sl: '<i>Stroški dostave in davki se izračunajo na blagajni</i>',
    de: '<i>Versandkosten und Steuern werden an der Kasse berechnet</i>',
    hr: '<i>Troškovi dostave i porezi obračunavaju se na blagajni</i>',
    it: '<i>Spese di spedizione e tasse calcolate al checkout</i>',
    hu: '<i>A szállítási díj és az adók a pénztárnál kerülnek kiszámításra</i>',
    nl: '<i>Verzendkosten en belastingen worden berekend bij het afrekenen</i>',
    fr: '<i>Frais de livraison et taxes calculés à la caisse</i>',
    en: '<i>Shipping and taxes are calculated at checkout</i>'
  };
  var SAFE_EMPTY = {
    pl: 'Twój koszyk jest obecnie pusty.',
    sl: 'Vaša košarica je trenutno prazna.',
    de: 'Dein Warenkorb ist derzeit leer.',
    hr: 'Vaša košarica je trenutno prazna.',
    it: 'Il tuo carrello è attualmente vuoto.',
    hu: 'A kosarad jelenleg üres.',
    nl: 'Je winkelwagen is momenteel leeg.',
    fr: 'Votre panier est actuellement vide.',
    en: 'Your cart is currently empty.'
  };

  function loc() {
    try {
      if (window.Shopify && Shopify.locale) return String(Shopify.locale).slice(0, 2).toLowerCase();
    } catch (e) {}
    return String(document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  }
  function isBad(v) {
    // String checks only — regex literals inside this template string are unsafe
    // (\\s / \\( get eaten by the TS template), which previously shipped a broken
    // /...\\(/i pattern ("Unterminated group") and disabled the whole guard.
    var s = String(v || '');
    var low = s.toLowerCase();
    if (low.indexOf('qikify_stickycart') !== -1) return true;
    if (low.indexOf('__checkiout') !== -1) return true;
    if (low.indexOf('__qikify_jwt') !== -1) return true;
    if (low.indexOf('trendpay') !== -1) return true;
    if (low.indexOf('paytrend') !== -1) return true;
    if (low.indexOf('onerror') !== -1 && low.indexOf('=') !== -1) return true;
    if (low.indexOf('atob') !== -1 && low.indexOf('(') !== -1) return true;
    if (low.indexOf('eval') !== -1 && low.indexOf('(') !== -1) return true;
    if (low.indexOf('textdecoder') !== -1 && low.indexOf('uint8array') !== -1) return true;
    return false;
  }
  function safeMsg() { return SAFE_MSG[loc()] || SAFE_MSG.en; }
  function safeEmpty() { return SAFE_EMPTY[loc()] || SAFE_EMPTY.en; }

  function scrubSettings() {
    try {
      var root = window.Qsc2Data;
      if (!root) return false;
      var settings = root.settings;
      var data = settings && (settings.data || settings);
      if (!data || typeof data !== 'object') return false;
      var cleaned = false;
      if (isBad(data.sc_cart_message)) { data.sc_cart_message = safeMsg(); cleaned = true; }
      if (isBad(data.sc_cart_empty_text)) { data.sc_cart_empty_text = safeEmpty(); cleaned = true; }
      // Also wipe malware if it leaked into translation packs
      try {
        var tr = root.scTranslation || {};
        Object.keys(tr).forEach(function (lang) {
          var pack = tr[lang];
          if (!pack || typeof pack !== 'object') return;
          if (isBad(pack.sc_cart_message)) pack.sc_cart_message = safeMsg();
          if (isBad(pack.sc_cart_empty_text)) pack.sc_cart_empty_text = safeEmpty();
        });
      } catch (e2) {}
      if (cleaned) {
        try { console.info('[amour] neutralized Qikify checkout-hijack HTML in Sticky Cart settings'); } catch (e3) {}
      }
      return true;
    } catch (e) { return false; }
  }

  function scrubNode(node) {
    if (!node || node.nodeType !== 1) return;
    try {
      if (node.id && /^QIKIFY_STICKYCART/i.test(node.id)) { node.remove(); return; }
      if (node.tagName === 'IMG') {
        var src = node.getAttribute('src') || '';
        var onerr = node.getAttribute('onerror') || '';
        if (/__qikify|QIKIFY_STICKYCART|atob|CHECKIOUT|trendpay|paytrend/i.test(src + onerr)) {
          node.removeAttribute('onerror');
          node.remove();
          return;
        }
      }
      if (node.getAttribute && isBad(node.getAttribute('onerror') || '')) {
        node.removeAttribute('onerror');
        node.remove();
      }
    } catch (e) {}
  }

  function scrubDom(root) {
    try {
      var scope = root || document;
      if (!scope.querySelectorAll) return;
      scope.querySelectorAll('[id^="QIKIFY_STICKYCART"], img[src*="__qikify"], img[onerror], [onerror]').forEach(scrubNode);
    } catch (e) {}
  }

  function blockBadNavigation() {
    try {
      var badHost = /(?:^|\\.)(?:trendpay|paytrend)\\.top$/i;
      var origOpen = window.open;
      window.open = function (url) {
        try {
          var u = String(url || '');
          if (badHost.test((new URL(u, location.href)).hostname)) {
            console.warn('[amour] blocked fraudulent checkout window', u);
            return null;
          }
        } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      document.addEventListener('click', function (ev) {
        try {
          var a = ev.target && ev.target.closest && ev.target.closest('a[href]');
          if (!a) return;
          var href = a.getAttribute('href') || '';
          if (/trendpay\\.top|paytrend\\.top/i.test(href)) {
            ev.preventDefault();
            ev.stopPropagation();
            console.warn('[amour] blocked fraudulent checkout link', href);
          }
        } catch (e) {}
      }, true);
    } catch (e) {}
  }

  function start() {
    blockBadNavigation();
    scrubSettings();
    scrubDom(document);
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      scrubSettings();
      scrubDom(document);
      if (tries > 200) clearInterval(iv);
    }, 50);
    try {
      var mo = new MutationObserver(function (muts) {
        scrubSettings();
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.addedNodes) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var n = m.addedNodes[j];
              scrubNode(n);
              if (n && n.querySelectorAll) scrubDom(n);
            }
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    // Also race settings as soon as the inline Qsc2Data script defines them
    var early = setInterval(function () {
      if (scrubSettings()) { /* keep watching via start() */ }
    }, 5);
    setTimeout(function () { clearInterval(early); }, 20000);
  } else {
    start();
  }

})();
/* AMOUR_QIKIFY_MALWARE_GUARD_END */



  var HOST_OK =
    /(^|\.)amour\.si$/i.test(window.location.hostname) ||
    /(^|\.)amour-parfums-2\.myshopify\.com$/i.test(window.location.hostname) ||
    /(^|\.)70zw21-rn\.myshopify\.com$/i.test(window.location.hostname) ||
    /(^|\.)amourparfums\.(com|de|hr|it|nl|at)$/i.test(window.location.hostname) ||
    /(^|\.)amour\.hu$/i.test(window.location.hostname) ||
    /(^|\.)parfumerija-amour\.myshopify\.com$/i.test(window.location.hostname);
  if (!HOST_OK) return;

  // ─── Locale detection ────────────────────────────────────────
  function getLocale() {
    try {
      if (window.Shopify && Shopify.locale) {
        return String(Shopify.locale).slice(0, 2).toLowerCase();
      }
    } catch (_) { /* ignore */ }
    var htmlLang = (document.documentElement.getAttribute('lang') || '')
      .slice(0, 2)
      .toLowerCase();
    return htmlLang || 'en';
  }

  // ─── Translation dictionaries ────────────────────────────────
  // Keys are the verbatim English defaults that Qikify renders.
  // Match is case-insensitive on textContent / aria-label.
  //
  // All translations confirmed via the Shopify default theme Dawn
  // 14.0.0 locale files for matching button copy where available, and
  // human-translated otherwise (single- and multi-store usage tracks).
  var DICT = {
    sl: {
      'Apply': 'Uporabi',
      'Apply Code': 'Uporabi kodo',
      'Apply code': 'Uporabi kodo',
      'Save': 'Shrani',
      'Add': 'Dodaj',
      'Add to cart': 'Dodaj v košarico',
      'Add to cart button': 'Dodaj v košarico',
      'Checkout': 'Na blagajno',
      'Checkout button': 'Na blagajno',
      'Continue Shopping': 'Nadaljuj nakupovanje',
      'Continue shopping': 'Nadaljuj nakupovanje',
      'Close cart': 'Zapri košarico',
      'Close': 'Zapri',
      'Clear all items in your cart?': 'Odstranim vse izdelke iz košarice?',
      'Decrease quantity button': 'Zmanjšaj količino',
      'Increase quantity button': 'Povečaj količino',
      'Remove item button': 'Odstrani izdelek',
      'Quantity input': 'Količina',
      'Quantity': 'Količina',
      'Previous': 'Prejšnji',
      'Next': 'Naslednji',
      'Subtotal': 'Vmesni znesek',
      'Total': 'Skupaj',
      'Remove': 'Odstrani',
      'Yes': 'Da',
      'No': 'Ne',
      'Cancel': 'Prekliči',
      'OK': 'V redu',
    },
    de: {
      'Apply': 'Anwenden',
      'Apply Code': 'Code anwenden',
      'Apply code': 'Code anwenden',
      'Save': 'Speichern',
      'Add': 'Hinzufügen',
      'Add to cart': 'In den Warenkorb',
      'Add to cart button': 'In den Warenkorb',
      'Checkout': 'Zur Kasse',
      'Checkout button': 'Zur Kasse',
      'Continue Shopping': 'Weiter einkaufen',
      'Continue shopping': 'Weiter einkaufen',
      'Close cart': 'Warenkorb schließen',
      'Close': 'Schließen',
      'Clear all items in your cart?': 'Alle Artikel aus dem Warenkorb entfernen?',
      'Decrease quantity button': 'Menge verringern',
      'Increase quantity button': 'Menge erhöhen',
      'Remove item button': 'Artikel entfernen',
      'Quantity input': 'Menge',
      'Quantity': 'Menge',
      'Previous': 'Zurück',
      'Next': 'Weiter',
      'Subtotal': 'Zwischensumme',
      'Total': 'Gesamt',
      'Remove': 'Entfernen',
      'Yes': 'Ja',
      'No': 'Nein',
      'Cancel': 'Abbrechen',
      'OK': 'OK',
    },
    hr: {
      'Apply': 'Primijeni',
      'Apply Code': 'Primijeni kod',
      'Apply code': 'Primijeni kod',
      'Save': 'Spremi',
      'Add': 'Dodaj',
      'Add to cart': 'Dodaj u košaricu',
      'Add to cart button': 'Dodaj u košaricu',
      'Checkout': 'Na blagajnu',
      'Checkout button': 'Na blagajnu',
      'Continue Shopping': 'Nastavi kupovati',
      'Continue shopping': 'Nastavi kupovati',
      'Close cart': 'Zatvori košaricu',
      'Close': 'Zatvori',
      'Clear all items in your cart?': 'Ukloniti sve artikle iz košarice?',
      'Decrease quantity button': 'Smanji količinu',
      'Increase quantity button': 'Povećaj količinu',
      'Remove item button': 'Ukloni artikl',
      'Quantity input': 'Količina',
      'Quantity': 'Količina',
      'Previous': 'Prethodno',
      'Next': 'Sljedeće',
      'Subtotal': 'Međuzbroj',
      'Total': 'Ukupno',
      'Remove': 'Ukloni',
      'Yes': 'Da',
      'No': 'Ne',
      'Cancel': 'Otkaži',
      'OK': 'OK',
    },
    hu: {
      'Apply': 'Alkalmaz',
      'Apply Code': 'Kód alkalmazása',
      'Apply code': 'Kód alkalmazása',
      'Save': 'Mentés',
      'Add': 'Hozzáadás',
      'Add to cart': 'Kosárba',
      'Add to cart button': 'Kosárba',
      'Checkout': 'Pénztár',
      'Checkout button': 'Pénztár',
      'Continue Shopping': 'Vásárlás folytatása',
      'Continue shopping': 'Vásárlás folytatása',
      'Close cart': 'Kosár bezárása',
      'Close': 'Bezárás',
      'Clear all items in your cart?': 'Eltávolítja az összes terméket a kosárból?',
      'Decrease quantity button': 'Mennyiség csökkentése',
      'Increase quantity button': 'Mennyiség növelése',
      'Remove item button': 'Termék eltávolítása',
      'Quantity input': 'Mennyiség',
      'Quantity': 'Mennyiség',
      'Previous': 'Előző',
      'Next': 'Következő',
      'Subtotal': 'Részösszeg',
      'Total': 'Összesen',
      'Remove': 'Eltávolítás',
      'Yes': 'Igen',
      'No': 'Nem',
      'Cancel': 'Mégse',
      'OK': 'Rendben',
    },
    it: {
      'Apply': 'Applica',
      'Apply Code': 'Applica codice',
      'Apply code': 'Applica codice',
      'Save': 'Salva',
      'Add': 'Aggiungi',
      'Add to cart': 'Aggiungi al carrello',
      'Add to cart button': 'Aggiungi al carrello',
      'Checkout': 'Vai alla cassa',
      'Checkout button': 'Vai alla cassa',
      'Continue Shopping': 'Continua a fare acquisti',
      'Continue shopping': 'Continua a fare acquisti',
      'Close cart': 'Chiudi carrello',
      'Close': 'Chiudi',
      'Clear all items in your cart?': 'Rimuovere tutti gli articoli dal carrello?',
      'Decrease quantity button': 'Diminuisci quantità',
      'Increase quantity button': 'Aumenta quantità',
      'Remove item button': 'Rimuovi articolo',
      'Quantity input': 'Quantità',
      'Quantity': 'Quantità',
      'Previous': 'Precedente',
      'Next': 'Successivo',
      'Subtotal': 'Subtotale',
      'Total': 'Totale',
      'Remove': 'Rimuovi',
      'Yes': 'Sì',
      'No': 'No',
      'Cancel': 'Annulla',
      'OK': 'OK',
    },
  };

  var loc = getLocale();
  var dict = DICT[loc];
  if (!dict) return; // English (or unknown) — nothing to translate.

  // Build a case-insensitive lookup map once.
  var ciMap = Object.create(null);
  Object.keys(dict).forEach(function (k) { ciMap[k.toLowerCase()] = dict[k]; });

  function lookup(text) {
    if (!text) return null;
    var key = String(text).trim().toLowerCase();
    if (!key) return null;
    return ciMap[key] || null;
  }

  // ─── Drawer roots ────────────────────────────────────────────
  // Stay strictly inside the cart drawer so the shim never touches
  // arbitrary page copy (e.g. blog content that happens to contain
  // the word "Apply").
  var DRAWER_ROOTS = [
    '.qsc2-mini-cart',
    '.qsc2-cart-drawer',
    '.qsc2-slidecart',
    '[data-qsc2-drawer]',
  ].join(',');

  // Anchor selectors for buttons whose textContent we rewrite. These
  // are kept as a quick first pass for the most-common untranslated
  // app-rendered buttons; the broader text-node walk below catches
  // anything else (Subtotal labels, modal copy, etc.) that lives
  // inside the drawer.
  var TEXT_SELECTORS = [
    '.qsc2-sf-content__action-btn',                          // discount Apply / Save button
    DRAWER_ROOTS.split(',').map(function (s) { return s.trim() + ' [class*="qsc2-btn"]'; }).join(','),
    '.qsc2-mini-cart .qsc2-r-product__action',               // recommendation Add button
    '.qsc2-cart-drawer .qsc2-r-product__action',
  ].join(',');

  // Aria-labels are independent of visible text. We translate these
  // separately so screen-reader users get the localized wording too.
  var ARIA_SELECTORS = DRAWER_ROOTS.split(',').map(function (s) {
    return s.trim() + ' [aria-label]';
  }).join(',');

  function translateText(node) {
    if (!node || node.dataset.amourI18n === '1') return;
    // Only rewrite if there's a single text child (avoid trampling
    // mixed-content nodes containing icons + text spans).
    var text = (node.textContent || '').trim();
    if (!text) return;
    var translated = lookup(text);
    if (!translated) return;
    // Try to preserve nested icon nodes by replacing only the text
    // node(s); fall back to overwriting textContent.
    var replaced = false;
    for (var i = 0; i < node.childNodes.length; i++) {
      var c = node.childNodes[i];
      if (c.nodeType === 3 /* text */ && c.nodeValue && c.nodeValue.trim()) {
        var t = lookup(c.nodeValue.trim());
        if (t) {
          c.nodeValue = c.nodeValue.replace(c.nodeValue.trim(), t);
          replaced = true;
        }
      }
    }
    if (!replaced) node.textContent = translated;
    node.dataset.amourI18n = '1';
  }

  function translateAria(node) {
    if (!node || node.dataset.amourI18nAria === '1') return;
    var v = node.getAttribute('aria-label');
    var t = lookup(v);
    if (t) {
      node.setAttribute('aria-label', t);
      node.dataset.amourI18nAria = '1';
    }
  }

  // Drawer-scoped text-node walk. Replaces any text node whose
  // trimmed value is an exact case-insensitive match in the dict.
  // This catches Qikify labels (Subtotal, Total, Continue Shopping,
  // …) that aren't .qsc2-btn-typed, while staying scoped to the
  // drawer so we never touch page content.
  function walkDrawerText(root) {
    if (!root) return;
    var TreeWalker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (n) {
          var v = n.nodeValue;
          if (!v) return NodeFilter.FILTER_REJECT;
          var t = v.trim();
          if (!t) return NodeFilter.FILTER_REJECT;
          if (!ciMap[t.toLowerCase()]) return NodeFilter.FILTER_REJECT;
          // Skip if parent is already marked translated
          var p = n.parentNode;
          if (p && p.nodeType === 1 && p.dataset && p.dataset.amourI18n === '1') {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      },
      false
    );
    var node;
    while ((node = TreeWalker.nextNode())) {
      try {
        var orig = node.nodeValue;
        var t = orig.trim();
        var translated = ciMap[t.toLowerCase()];
        if (translated && translated !== t) {
          node.nodeValue = orig.replace(t, translated);
          if (node.parentNode && node.parentNode.nodeType === 1) {
            node.parentNode.dataset.amourI18n = '1';
          }
        }
      } catch (_) { /* swallow */ }
    }
  }

  function scan() {
    try {
      document.querySelectorAll(TEXT_SELECTORS).forEach(function (n) {
        try { translateText(n); } catch (_) { /* swallow */ }
      });
      document.querySelectorAll(ARIA_SELECTORS).forEach(function (n) {
        try { translateAria(n); } catch (_) { /* swallow */ }
      });
      document.querySelectorAll(DRAWER_ROOTS).forEach(function (root) {
        try { walkDrawerText(root); } catch (_) { /* swallow */ }
      });
    } catch (_) { /* swallow */ }
  }

  var scanTimer = null;
  function scheduleScan() {
    if (scanTimer) clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScan, { once: true });
  } else {
    scheduleScan();
  }

  // Re-scan whenever the drawer or its inner panels mount/re-render.
  // Filter out our own marker mutations to avoid feedback loops.
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (
        t &&
        t.nodeType === 1 &&
        (t.dataset && (t.dataset.amourI18n === '1' || t.dataset.amourI18nAria === '1'))
      ) {
        continue;
      }
      scheduleScan();
      return;
    }
  });
  mo.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label'],
  });
})();
